import React from 'react';
import LoginForm from './LoginForm';
import { Col, Row } from 'reactstrap';
import ActivateCode from '../../components/ActivateCode';
import cx from 'classnames';

/**
 * Container para formularios
 * Se puede incluir  logica para definir una pagina de ingreso
 * o de registración en caso de ingresar un codigo.
 *
 * - Si es para solo login se debe incluir solamente el <LoginForm/>
 *
 * @class FormContainer
 * @extends {React.Component}
 */

const FormContainer = (props) => {
  const { api, location } = props;

  const [isValidPasswordLessFlow, setIsValidPasswordLessFlow] = React.useState(false);
  const [username, setUsername] = React.useState(false);

  return (
    <div className="centered-container">
      <Row className="no-gutters">
        <Col
          xs="12"
          sm="12"
          md="12"
          lg="12"
          xl="12"
          className="mx-auto"
        >
          {!isValidPasswordLessFlow &&
            <LoginForm
              api={api}
              location={location}
              setUsername={setUsername}
              setIsValidPasswordLessFlow={setIsValidPasswordLessFlow}
            />
          }
          {isValidPasswordLessFlow &&
            <ActivateCode
              username={username}
              api={api}
              location={location}
              setIsValidPasswordLessFlow={setIsValidPasswordLessFlow}
            />
          }
        </Col>
      </Row>
    </div>
  );
};

export default FormContainer;
////////////////////////////
